<div class="reelax-white-bg" *transloco="let t">
  <div class="light-reelax-gradient-bg">
    <div class="first-part">
      <div class="first-part__column">
        <h1 class="title --home">
          {{ t('homeFan.sellBuy') }}<br>
          {{ t('homeFan.realTickets') }}<br>
          {{ t('homeFan.fairPrice') }}
        </h1>
        <p class="first-part__column__text">
          {{ t('homeFan.workWithOrganizers') }}
        </p>
        <div class="show-on-large-only">
          <div class="made-in">
            <img alt="france" src="assets/img/flag-france.svg">
            <span class="fw-700">{{ t('homeFan.frenchFirst') }}</span>
          </div>
        </div>
        <div class="buttons-group --row">
          <a mat-button class="button --full-width --small --primary my-4" [routerLink]="ROUTES.EVENTS">    
            {{ 'button.resaleATicket' | transloco }}
          </a>
        </div>
      </div>
      <div class="first-part__column show-on-large-only">
        <div class="carousels --events">
          <app-events-carousel-vertical [events]="eventsOdd"/>
          <app-events-carousel-vertical [events]="eventsEven" [reverse]="true"/>
        </div>
      </div>
    </div>

    <div class="hide-on-large-only">
      <app-all-events-carousel [events]="events"/>
      <div class="made-in center">
        <img alt="france" src="assets/img/flag-france.svg">
        <span class="fw-700">{{ t('homeFan.frenchFirst') }}</span>
      </div>
    </div>

    <div class="triangle-separator"></div>
  </div>

  <div class="page-container">
    <div id="reasons">
      <app-fan-reasons/>
    </div>
    
    <div id="feedbacks" class="pt-4">
      <h3 class="fragment-title reelax-white-bg pb-0">{{ t('homeFan.theySayit') }}</h3>
    </div>
  </div>

  
  <div class="light-reelax-gradient-bg">
    <div class="triangle-separator --reverse"></div>

    <div class="page-container fan-container">
      <div class="carousels">
        <app-feedbacks-carousel-vertical class="carousels__feedbacks" [feedbacks]="feedbacks1"/>
        <app-feedbacks-carousel-vertical class="hide-on-extra-small-only carousels__feedbacks" [feedbacks]="feedbacks2" [reverse]="true"/>
        <app-feedbacks-carousel-vertical class="show-on-large-only carousels__feedbacks" [feedbacks]="feedbacks3"/>
      </div>
    </div>

    <div class="triangle-separator"></div>
  </div>

  <div id="partners" class="organizer">
    <div class="page-container">
      <h3 class="title fragment-title">{{ t('homeFan.areYouOrganizer') }}</h3>
      <p class="organizer__text">
        {{ t('homeFan.joinUs') }}
      </p>
    </div>
    <app-all-organizers-carousel/>
    <div class="page-container pb-4">
      <div class="buttons-group --row small-container">
        <a mat-button class="button --full-width --small --primary" [routerLink]="ROUTES.DEMO">
          {{ t('homeFan.askForDemo') }}
        </a>
    </div>
  </div>

  <div id="partners" class="py-4">
    <div class="page-container">
      <h3 class="fragment-title">{{ t('homeFan.onTheNews') }}</h3>
    </div>
    <app-all-press-articles-carousel/>
  </div>

</div>
